import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { FunctionParametersSettingsWeltico2ClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-weltico2-clock-screen/function-parameters-settings-weltico2-clock-screen.component';
import { FunctionParametersSettingWeltico2ClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-weltico2-clock-week-screen/function-parameters-setting-weltico2-clock-week-screen.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { MinuterieLabelComponent } from '../../../../../../../../components/ecosystems/minuterie-label/minuterie-label.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { P0003600DureeAjustementLoiEau } from '../../../Enum/P0003600DureeAjustementLoiEau';
import {
  P0003600ProgrammeFiltrationAuto,
  P0003600ProgrammeFiltrationAutoSans,
} from '../../../Enum/P0003600ProgrammeFiltrationAuto';
import { convertMinutesToTime } from '../../../../../../helper/convertSecondsToTime';
import { P0003600EnSavoirPlusComponent } from '../../enSavoirPlus/p0003600-en-savoir-plus/p0003600-en-savoir-plus.component';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { P0003600SeuilTemperatureFiltration2424 } from '../../../Enum/P0003600SeuilTemperatureFiltration2424';
import { getTemperatureType } from '../../../../../../helper/temperature';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { IonLabel } from '@ionic/angular/standalone';
import { P0003600TypeFonctionHorsGelEnum } from '../../../Enum/P0003600TypeFonctionHorsGelEnum';
import { P0003600CapteurTemperatureEnum } from '../../../Enum/P0003600CapteurTemperatureEnum';
import { P0003600SeuilTemperatureHorsGel } from '../../../Enum/P0003600SeuilTemperatureHorsGel';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';

@Component({
  selector: 'app-p0003600-filtration-parameters',
  templateUrl: './p0003600-filtration-parameters.component.html',
  styleUrls: ['./p0003600-filtration-parameters.component.scss'],
  imports: [
    LabelConfigurationComponent,
    LargedLinkComponent,
    MinuterieLabelComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
    SwitchConfigurationComponent,
    AffichageWarningComponent,
    IonLabel,
    LabelDescriptionComponent,
  ],
})
export class P0003600FiltrationParametersComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
  }

  hasProduitP00030() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00030()) ?? 0;
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalService.create({
      component: P0003600EnSavoirPlusComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fsPHorlogePicotJourPPH'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage3,
        'fsPHorlogePicotJourPPH',
        hj,
      );

      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fsPHorlogePicotSemainePPH'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage3,
        'fsPHorlogePicotSemainePPH',
        hj,
      );

      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingsClockPPEScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fsPHorlogePicotJourPPE'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage2,
        'fsPHorlogePicotJourPPE',
        hj,
      );

      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingClockWeekPPEScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fsPHorlogePicotSemainePPE'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage2,
        'fsPHorlogePicotSemainePPE',
        hj,
      );

      this.actionStack!.commit();
    }
  }

  protected readonly P0003600DureeAjustementLoiEau =
    P0003600DureeAjustementLoiEau;
  protected readonly P0003600ProgrammeFiltrationAuto =
    P0003600ProgrammeFiltrationAuto;
  protected readonly convertMinutesToTime = convertMinutesToTime;
  protected readonly P0003600ProgrammeFiltrationAutoSans =
    P0003600ProgrammeFiltrationAutoSans;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003600SeuilTemperatureFiltration2424 =
    P0003600SeuilTemperatureFiltration2424;
  protected readonly getTemperatureType = getTemperatureType;
  protected readonly P0003600TypeFonctionHorsGelEnum =
    P0003600TypeFonctionHorsGelEnum;
  protected readonly P0003600CapteurTemperatureEnum =
    P0003600CapteurTemperatureEnum;
  protected readonly P0003600SeuilTemperatureHorsGel =
    P0003600SeuilTemperatureHorsGel;
}
